import type { IScope } from "angular";
import { finalize } from "rxjs/operators";

import { forIn } from "lodash";

import type { IResponseWithLoading, ISiteEquipmentSlim } from "App/Modules/Models";
import { EquipmentClass } from "App/Modules/Models";
import type { ISiteEquipmentRepository } from "App/Modules/Repositories";
import type { IFormContainerResolve } from "App/Modules/Services";
import { extendWithLoadingAndFail } from "App/Modules/Services/ObservableExtensions";

export default class AddSiteEquipmentComponentController {
    public static $inject: string[] = ["$scope", "mmSiteEquipmentRepository"];

    public equipmentClasses: string[];

    public siteEquipment: ISiteEquipmentSlim;

    public resolve: IFormContainerResolve<ISiteEquipmentSlim, string>;

    public addResponse: IResponseWithLoading<ISiteEquipmentSlim>;

    constructor(private readonly $scope: IScope, private readonly siteEquipmentRepository: ISiteEquipmentRepository) {}

    public $onInit() {
        const equipmentClasses: string[] = [];
        forIn(EquipmentClass, (value, key) => {
            if (typeof value === "number") {
                equipmentClasses.push(key);
            }
        });
        equipmentClasses.sort();

        this.equipmentClasses = equipmentClasses;
    }

    public cancel() {
        if (this.resolve.options.onCancel) {
            this.resolve.options.onCancel();
        }
    }

    public addSiteEquipment() {
        extendWithLoadingAndFail(
            this.siteEquipmentRepository.addSiteEquipment(this.resolve.bindings, this.siteEquipment),
        )
            .pipe(finalize(() => this.$scope.$applyAsync()))
            .subscribe(
                (response: IResponseWithLoading<ISiteEquipmentSlim>) => {
                    this.addResponse = response;
                    if (!response.isLoading && response.data) {
                        this.resolve.options.onOk(response.data);
                    }
                },
                (error) => {
                    this.addResponse = error;
                },
            );
    }
}
